module.exports = __webpack_public_path__ + "img/printer_inactive.f3bcec4b.svg";